import React, { FC } from "react";

interface DocumentFile {
  url: string
  fileName: string
}

interface ButtonFile {
  id: string
  title: string
  file: DocumentFile
}

interface DownloadStrengthenFinancialSystemButtonProps { 
  buttonLabel: string
  buttonFile: ButtonFile
}

export const DownloadStrengthenFinancialSystemButton: FC<DownloadStrengthenFinancialSystemButtonProps> = ({ buttonLabel, buttonFile }) => {

  const downloadFile = async () => {
    const response = await fetch(buttonFile.file.url);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${buttonFile.file.fileName}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <section className="whitePaperDownload">
      <div className="wrapper wrapper_lg resource">
        {buttonLabel &&
          <button
            className="link link_white link_full cta--link"
            onClick={() => {
              downloadFile();
            }}
            data-title={buttonLabel}
          >
            <span>{buttonLabel}</span>
          </button>
        }
      </div>
    </section>
  )
};
